/**
 * Application methods
 */
import register from './register';

/**
 * Plugin server methods
 */

import controllers from './controllers';
import routes from './routes';

export default {
  register,
  controllers,
  routes
};
